import { FormControl, FormGroup } from '@angular/forms';
import { PropertyMetadata } from '../../../properties/property-types';
import { RegisterElement } from '../../element-decorator';
import { PolygonDecorationMapItem } from '../polygon-decoration-map-item';
import { MeshConstants } from 'src/app/util/mesh-constants';

@RegisterElement()
export class SmallTree extends PolygonDecorationMapItem {
    public override TypeName: string = 'SmallTree';

    constructor(formGroup: FormGroup) {
        super(formGroup, "SmallTree", 'assets/icons/smalltree.svg', 2, MeshConstants.smalltreesdistance * 1000);

        if (!formGroup.contains('Name')) {
            formGroup.addControl('Name', new FormControl(''));
        }
    }

    public override clone(): SmallTree {
        return new SmallTree(this.formGroup);
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            {
                formControlName: 'Name',
                displayName: 'Name',
                inputType: { type: 'text' },
                order: 1,
                category: 'General'
            }
        ];
    }

    public override default(): SmallTree {
        return this;
    }
}
